/*
  コンテンツのフェードアニメーションです。
  フェードアニメーションで表示させる親要素に `.js-fade-wrap` をつけて、
  子要素に `data-fade=""` をつけ、順番を指定します。
  → `data-fade="3"` 親要素表示から1秒後にフェードイン
  5番目まで定義してありますが、必要に応じて足したりしてください。 switch文のとこ

  パ
*/

import 'intersection-observer';
import IntersectionObserver from 'intersection-observer-polyfill/dist/IntersectionObserver.js';
import buildThresholdsList from '../utils/buildThresholdsList';
import { gsap, TweenLite, CSSPlugin, Power2 } from 'gsap/all';

gsap.registerPlugin(CSSPlugin);

export default class ContentsAnimation {
  constructor() {
    this.io = new IntersectionObserver(this.onIntersect.bind(this), {
      root: null,
      rootMargin: '0% 0% -20% 0%',
      threshold: buildThresholdsList(10)
    });

    //document.addEventListener('DOMContentLoaded', () => {
      this.wrappers = document.querySelectorAll('.js-fade-wrap');
      TweenLite.set('.js-fade-item', { opacity: 0, y: "+=20" });

      for (let i = 0, leng = this.wrappers.length; i < leng; i++) {
        this.io.observe(this.wrappers[i]);
      }
    //});

    window.addEventListener('load', () => {
      TweenLite.to('.firstview__soundTrigger', .7, { opacity: 1, y: '-=20', ease: Power2.easeOut });
      TweenLite.to('.firstview__scrollguide', .7, { opacity: 1, y: 0, ease: Power2.easeOut,
        onComplete() {
          TweenLite.to('.firstview__product', 1, { opacity: 1, y: 0, ease: Power2.easeOut });
        }
      });
    });
  }

  onIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
        const animationTarget = entry.target.querySelectorAll('.js-fade-item');
        for (let i = 0, leng = animationTarget.length; i < leng; i++) {
          this.setQueue(animationTarget[i]);
        }
        observer.unobserve(entry.target);
      }
    });
  }

  assignDelay(order) {
    if (typeof order !== 'number') return 0;
    let delay = 0;
    switch (order) {
      case 1:
        delay = 0;
        break;
      case 2:
        delay = 0.7;
        break;
      case 3:
        delay = 1.0;
        break;
      case 4:
        delay = 1.3;
        break;
      case 5:
        delay = 1.6;
        break;
      case 6:
        delay = 1.9;
        break;
      case 7:
        delay = 2.2;
        break;
      default:
        delay = 0;
        break;
    }

    return delay;
  }

  setQueue(element) {
    const dataValue = element.dataset.fade;
    const delay = this.assignDelay(Number(dataValue));
    this.showContents(element, delay);
  }

  showContents(element, delay) {
    return TweenLite.to(element, .7, { opacity: 1, y: 0, ease: Power2.easeOut, delay: delay });
  }
}
